import Hero from "../components/Home/Hero";
import TopDonators from "../components/Home/TopDonators";
import Voting from "../components/Home/Voting";
import News from "../components/Home/News";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { modalActions } from "../storage/modals";

const ServerMain = (params) => {
  const loadedContent = params.content;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if(loadedContent.redirect){
        navigate(loadedContent.direction);
    }
    else{
        dispatch(modalActions.setTopDonatorsDescriptionImg(loadedContent.hero.top_donators));
    }
  }, [loadedContent, navigate, dispatch]);

  return (
    <>
      {loadedContent.hero && <Hero content={loadedContent.hero} />}
      {loadedContent.top && loadedContent.top.donators.length > 0 && (
        <TopDonators content={loadedContent.top} />
      )}
      {loadedContent.voting && <Voting content={loadedContent.voting} bg={loadedContent.hero.voting_bg} />}
      {loadedContent.news && loadedContent.news.news.length > 0 && (
        <News content={loadedContent.news} />
      )}
    </>
  );
};

export default ServerMain;
